export default function createWallsWorker() {
  return new Worker(new URL('./wallsWorker.js', import.meta.url));
}
